export const jsonParse = (value, fallback) => {
  try {
    return JSON.parse(value)
  } catch (e) {
    if (fallback) return fallback

    return {}
  }
}

export const stringToObject = (str, defaultReturn) => {
  if (!str || !str.length)
    return typeof defaultReturn === 'undefined' ? [] : defaultReturn
  try {
    return JSON.parse(str)
  } catch (e) {
    return typeof defaultReturn === 'undefined' ? [] : defaultReturn
  }
}

// eslint-disable-next-line no-restricted-globals
export const currentWidth = screen.width
